export default "/_next/static/images/effect-left-4-53b2e00684b5704a10193739ecd3096d.svg";